import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  formItem: {
    marginBottom: 0
  },
  verifyEmailContent: {
    maxWidth: 360,
    marginInline: 'auto'
  },
  tryAgainButton: {
    paddingInline: 4
  },
  linkButton: {
    color: token.orange,
    ':hover': {
      color: `${token.orange} !important`
    }
  },
  otpWrapper: {
    gap: 12
  },

  otpInput: {
    maxWidth: 64,
    height: 80,
    fontSize: 32
  }
}))
